// @ts-ignore
import styles from './VideoLibrary.module.scss';
import { useState } from 'react';
import VideoFolder from './VideoFolder';
import VideoThumbnail from './VideoThumbnail';
import Text from '../../Base/Text/Text';

interface VideoLibrary {}

export default function VideoLibrary(props: VideoLibrary) {
	const {} = props;

	return (
		<div className={styles.wrapper}>
			<Text
				tx={'Seleccione el/los videos a brindar al paciente'}
				className={'mb-3'}
			/>
			<div className={'row mb-3'}>
				<div className={'col-lg-3 col-md-4 col-12'}>
					<VideoFolder title={'Cardiología'} active />
				</div>
			</div>
			<div className={'row'}>
				<div className={'col-lg-3 col-md-4 col-12'}>
					<VideoThumbnail
						src={'https://player.vimeo.com/video/699153690?h=0a61e2a7be'}
						title={
							'Testovací název video o diabetes super dlouhý nevím jak moc'
						}
					/>
				</div>
				<div className={'col-lg-3 col-md-4 col-12'}>
					<VideoThumbnail
						src={'https://player.vimeo.com/video/699153690?h=0a61e2a7be'}
						title={
							'Testovací název video o diabetes super dlouhý nevím jak moc'
						}
					/>
				</div>
				<div className={'col-lg-3 col-md-4 col-12'}>
					<VideoThumbnail
						src={'https://player.vimeo.com/video/699153690?h=0a61e2a7be'}
						title={
							'Testovací název video o diabetes super dlouhý nevím jak moc'
						}
					/>
				</div>
				<div className={'col-lg-3 col-md-4 col-12'}>
					<VideoThumbnail
						src={'https://player.vimeo.com/video/699153690?h=0a61e2a7be'}
						title={
							'Testovací název video o diabetes super dlouhý nevím jak moc'
						}
					/>
				</div>
			</div>
			<div className={'row mb-3 mt-5'}>
				<div className={'col-lg-3 col-md-4 col-12'}>
					<VideoFolder title={'Nutrición'} />
				</div>
			</div>
			<div className={'row'}>
				<div className={'col-lg-3 col-md-4 col-12'}>
					<VideoThumbnail
						src={'https://player.vimeo.com/video/699153690?h=0a61e2a7be'}
						title={
							'Testovací název video o diabetes super dlouhý nevím jak moc'
						}
					/>
				</div>
				<div className={'col-lg-3 col-md-4 col-12'}>
					<VideoThumbnail
						src={'https://player.vimeo.com/video/699153690?h=0a61e2a7be'}
						title={
							'Testovací název video o diabetes super dlouhý nevím jak moc'
						}
					/>
				</div>
				<div className={'col-lg-3 col-md-4 col-12'}>
					<VideoThumbnail
						src={'https://player.vimeo.com/video/699153690?h=0a61e2a7be'}
						title={
							'Testovací název video o diabetes super dlouhý nevím jak moc'
						}
					/>
				</div>
				<div className={'col-lg-3 col-md-4 col-12'}>
					<VideoThumbnail
						src={'https://player.vimeo.com/video/699153690?h=0a61e2a7be'}
						title={
							'Testovací název video o diabetes super dlouhý nevím jak moc'
						}
					/>
				</div>
			</div>
		</div>
	);
}
